<template>
  <b-row class="match-height">
    <b-col>
      <b-tabs>
        <b-tab active :title="$t('campaignactive')"> 
          <campaign-empty-state v-if="!loading && activeCampaigns.length === 0" />
          <b-row
            class="mt-3"
            :key="changeKey"
            v-if="activeCampaigns.length > 0"
          >
            <b-col
              v-for="(campaignInfo, index) in activeCampaigns"
              :key="index"
              lg="4"
              style="position:relative"
            >
              <CampaignCard 
                :campaignData="campaignInfo" 
                @has_been_archived="onArchived" 
                @deletedCampaign="onDeletedCampaign"
              />
            </b-col>
          </b-row>
        </b-tab>
        <b-tab :title="$t('campaigninactive')">
          <campaign-empty-state v-if="!loading && archivedCampaigns.length === 0" />
          <b-row
            class="mt-3" 
            :key="changeKey"
            v-if="archivedCampaigns.length > 0"
          >
            <b-col
              v-for="(campaignInfo, index) in archivedCampaigns"
              :key="index"
              lg="4"
            >
              <CampaignCard 
                :campaignData="campaignInfo" 
                @has_been_desarchived="onDesarchived" 
                :campaignArchived="true" 
                @deletedCampaign="onDeletedCampaign"
              />
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BTabs, BTab } from 'bootstrap-vue'

export default {
  name: 'CampaignTabs',
  components: {
    BRow,
    BCol,
    BTabs,
    BTab,
    CampaignCard: () => import('@/views/components/campaign/campaignCard.vue'),
    CampaignEmptyState: () => import('./CampaignEmptyState.vue')
  },
  props: {
    activeCampaigns: {
      type: Array,
      default: () => []
    },
    archivedCampaigns: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    changeKey: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onArchived(data) {
      this.$emit('archived', data)
    },
    onDesarchived(data) {
      this.$emit('desarchived', data)
    },
    onDeletedCampaign(isArchived, uuid) {
      this.$emit('deleted', isArchived, uuid)
    }
  }
}
</script>

<style scoped lang="scss">
</style>
